<template>
<div>
    <h2 class="page-title">Moje članarine </h2>  
    <v-data-table
        :headers="headers"
        :items="periods"
        :items-per-page="10"
        class="elevation-1">

        <template v-slot:item.start_date="{ item }">
            {{ item.start_date }} - {{ item.end_date }}
        </template>
    
    </v-data-table>
</div>
</template>


<script>
import PortalLayout from '@/js/Layouts/PortalLayout'
export default{
    metaInfo(){
        return{
             title: (this.$page.props.lang.measurement || "Članarine")
        }
    },
   
    layout: PortalLayout,
    props: {
       periods: Array        
    },
    data(){
      return {
        measurementsData: this.measurements,
        startDatePicker: false,
        editStartDatePicker: false,
        responseErrors: {},
       
        headers: [
                {text: this.$page.props.lang.membership || 'Članarina', value: 'name', align: 'start'},
                {text: this.$page.props.lang.height || 'Važenje', value: 'start_date', sortable: false, align:'start'},
                {text: this.$page.props.lang.weight || 'Perostalo', value: 'remaining', sortable: false, align: 'left'},
                {text: this.$page.props.lang.bmi || 'Status', value: 'status', sortable: false, align: 'center'}
            ],
      }
    },
    mounted(){
        this.renderChart = true
    },

    created(){

        var data = this.measurementsData.map(item => {
                return item.weight
                });
                this.currentDataSet = [{
                    name: this.$page.props.lang.weight || 'Weight(kg)', chartType: 'line',
                    values: data
                }];
                this.chartLabelsSet = this.measurementsData.map(item => {
                    return moment(item.data).format('DD.MM.YYYY')
                })

        this.setUpTableHeaders();
        this.addCustomsToChart();
    },

    methods:{

        setUpTableHeaders(){
          
            this.customs.forEach(item => {
                let customObjHeaders = {};

                customObjHeaders.text = item.label+'('+item.type+')';
                customObjHeaders.value = item.order_number.toString();
                customObjHeaders.align = 'center';
                customObjHeaders.sortable = 'false';

                return this.measurementsHeaders.push(customObjHeaders);
            });
        },

        addCustomsToChart(){
            
            this.customs.forEach(element => {

                const chartCount = this.items.length;
                const lastItem = this.items[chartCount - 1]['value'];
                let customMeasurementObj = {};
                customMeasurementObj.text = element.label+'('+element.type+')';
                customMeasurementObj.value = 'cust-'+element.id;

                return this.items.push(customMeasurementObj);
                
            });            

        },

        chartSelect(){
            axios.get('/portal/measurement/getChartData/'+ this.selectedChart.value +'/'+ this.member.id)
                .then(response => {
                    if(response.data.status === "OK"){
                        this.chartLabelsSet = response.data.labels;
                        this.chartDataSet = response.data.chartData;
                        this.chartDataSet.name = this.selectedChart.text;
                        this.chartDataSet.chartType = 'line',
                        this.currentDataSet.splice(0, 1, this.chartDataSet);
                    }else{
                        EventBus.$emit('SHOW_NOTIFICATION',{ 
                                message: response.data.message,
                                color: 'error',
                                timeout: 5000
                            })
                    }
                });
        },

       
    }
 
}

</script>